<template>
  <div :class="$options.$styles.effects">
    <item-animator :items="effects || []" data-test="effectsList">
      <template v-slot="item">
        <effect :data="item" :affected="affected" />
      </template>
    </item-animator>

    <div :class="$options.$styles.effectsAdder" key="effectAdder">
      <add-field
        @submit="createEffect"
        button-title="Add effect"
        form-classes="grid columns-var"
        form-style="--grid-template-columns-var: 1fr 2.5em"
        placeholder="New effect"
      ></add-field>
    </div>
  </div>
</template>

<script>
import Effect from './Effect'
import AddField from './AddField'
import ItemAnimator from './ItemAnimator'
import { mapActions } from 'vuex'

export default {
  name: `EffectsList`,

  components: {
    AddField,
    ItemAnimator,
    Effect,
  },

  props: [`effects`, `affected`],

  methods: {
    ...mapActions(`effect`, [`create`]),

    createEffect({ target }) {
      this.create({
        name: target.field.value,
        affected: this.affected,
      })
      target.reset()
    },
  },

  $styles: {
    effects: `
      c-effects__wrap max-md:-mt-8 max-md:pt-1 max-md:ml-1/4 md:mt-1 md:w-1/2 ml-auto relative
    `,
    effectsAdder: `
      js-effect-adder leading-none text-var-sm
    `,
  },
}
</script>
